"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartQuickItemAdd = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
// import { AnchorTrackingProps } from './CartPane';
const Input_1 = require("./../Input");
const Button_1 = require("./../Button");
const translations_1 = require("../../i18n/translations");
function CartQuickItemAdd(_a) {
    var { className, handleOnClick, defaultInput, quickAddError, locale } = _a, props = __rest(_a, ["className", "handleOnClick", "defaultInput", "quickAddError", "locale"]);
    const { asideQuickAddLabel, asideQuickAddButtonText } = translations_1.cartAsideContent[locale];
    const [productId, setProductId] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        setProductId('');
    }, [defaultInput]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('w-full max-w-full p-4 px-6 rounded-2xl shadow-md-all bg-white text-gray font-sofia', className) }, props),
        react_1.default.createElement("label", { htmlFor: "quick-item-add", className: "mb-2 inline-block" }, asideQuickAddLabel),
        react_1.default.createElement("div", { className: "flex flex-row w-full" },
            react_1.default.createElement(Input_1.Input, { id: "quick-item-add", "data-testid": "quick-item-add-input", className: (0, classnames_1.default)('py-1.5 grow w-full'), onChange: (e) => setProductId(e.target.value), value: productId, onKeyPress: (event) => {
                    if (event.key === 'Enter') {
                        handleOnClick(productId);
                    }
                } }),
            react_1.default.createElement(Button_1.Button, { className: (0, classnames_1.default)('atc-btn-quickadd ml-2 font-sofia'), variant: "blue", onClick: () => handleOnClick(productId), "data-testid": "quick-item-add-button" }, asideQuickAddButtonText)),
        quickAddError && (react_1.default.createElement("div", { className: "bg-red-alertbg text-red-alerttext text-sm rounded-md px-4 py-3 mt-2", role: "alert" },
            react_1.default.createElement("p", null, quickAddError)))));
}
exports.CartQuickItemAdd = CartQuickItemAdd;
